import { MenuItem, Select, Typography } from "@mui/material";
import UserAvatar from "./EIComponents/UserAvatar";

export default function AdminList({list, selected, onSelect, editable=true}) {
    
    console.log("LIST", list)

    return (
        <Select
            displayEmpty
            value={selected}
            disabled={!editable}
            onChange={(event) => { onSelect(event.target.value) }}
            sx={{borderRadius: "10px", height: "26px", width: "50%"}}
            renderValue={(selectedValue) => {
                if (!selectedValue) {
                    return <span style={{ color: "#858585" }}>{"Не выбран"}</span>;
                }
                return (
                    <div style={{display: "flex", flexDirection: 'row', alignItems: "center"}}>
                        <UserAvatar 
                            src={selectedValue.data.photo} 
                            userData={selectedValue} 
                            user_id={selectedValue.userId} 
                            size={20}
                            marginRight="10px"
                        />
                        <Typography variant="body1" sx={{ ml: 1}}>
                            {selectedValue.fio}
                        </Typography>
                    </div>
                )
            }}
        >
            {list.filter((el) => el.deleted !== 1).map(sel => 
                <MenuItem key={sel} value={sel} style={{ borderRadius: '10px', marginBottom: '5px' }}>
                    <div style={{display: "flex", flexDirection: 'row', alignItems: "center"}}>
                        <UserAvatar 
                            src={sel.data.photo} 
                            userData={sel} 
                            user_id={sel.userId} 
                            size={20}
                            marginRight="10px"
                        />
                        <Typography variant="body1" sx={{ ml: 1}}>
                            {sel.fio}
                        </Typography>
                    </div>
                </MenuItem> 
            )}
        </Select>
    )
}
